import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';

import { createRoot } from "react-dom/client";
import AppRoutes from "./AppRoutes";
const container = document.getElementById("root");
const root = createRoot(container);
root.render(<AppRoutes />);